import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Image from '../components/image';
export const _frontmatter = {
  "Title": "how does it work?"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "how-does-it-work"
    }}>{`How does it work?`}</h1>
    <p>{`At the core of a React-Sim simulation is the `}<inlineCode parentName="p">{`Model`}</inlineCode>{`.`}</p>
    <Image name="model" mdxType="Image" />
    <p>{`The `}<inlineCode parentName="p">{`Model`}</inlineCode>{` maintains three key pieces of information:`}</p>
    <Image name="modelState" mdxType="Image" />
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`params`}</inlineCode>{`, parameters of the simulation which don't change without a user intervention,`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`tick`}</inlineCode>{`, a measure of the progression of the simulation, which may increase automatically over time, and`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`data`}</inlineCode>{`, data for the simulation which will be updated at each new tick.`}</li>
    </ul>
    <Image name="modelComponents" mdxType="Image" />
    <p>{`To make a simulation work, the model has to interact with several other parts of the simulation:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`controls`}</inlineCode>{`, which will handle how users interact with the simulation,`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`initData`}</inlineCode>{`, which is run at the beginning of the simulation, to create the initial dataset,`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`updateData`}</inlineCode>{`, which is run each time the `}<inlineCode parentName="li">{`tick`}</inlineCode>{` changes,`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`frame`}</inlineCode>{`, which will render the simulation for each tick.`}</li>
    </ul>
    <p>{`Let's see how they work.`}</p>
    <h2 {...{
      "id": "controls"
    }}>{`Controls`}</h2>
    <Image name="modelControls" mdxType="Image" />
    <p>{`Controls let users interact with the simulation. Through `}<inlineCode parentName="p">{`controls`}</inlineCode>{`, users can play or pause the simulation, when applicable, jump to a point in time, or control the parameters.`}</p>
    <p>{`Controls enable developers to describe a UI for these interactions, using things like sliders, textboxes, toggles etc. (or bring your own).`}</p>
    <p>{`Controls get to change both the `}<inlineCode parentName="p">{`params`}</inlineCode>{` and the `}<inlineCode parentName="p">{`tick`}</inlineCode>{` inside the `}<inlineCode parentName="p">{`Model`}</inlineCode>{`. Controls can't access or change the `}<inlineCode parentName="p">{`data`}</inlineCode>{` though.`}</p>
    <h2 {...{
      "id": "initdata"
    }}>{`initData`}</h2>
    <Image name="modelInitData" mdxType="Image" />
    <p><inlineCode parentName="p">{`initData`}</inlineCode>{` generates the dataset at the start of the simulation. It can read the model's `}<inlineCode parentName="p">{`params`}</inlineCode>{`, and replace its `}<inlineCode parentName="p">{`data`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "updatedata"
    }}>{`updateData`}</h2>
    <Image name="modelUpdateData" mdxType="Image" />
    <p>{`Each time the `}<inlineCode parentName="p">{`tick`}</inlineCode>{` changes, `}<inlineCode parentName="p">{`updateData`}</inlineCode>{` will generate a new dataset, as a function of:`}</p>
    <ul>
      <li parentName="ul">{`the existing `}<inlineCode parentName="li">{`data`}</inlineCode>{`,`}</li>
      <li parentName="ul">{`the `}<inlineCode parentName="li">{`params`}</inlineCode>{`,`}</li>
      <li parentName="ul">{`the value of the `}<inlineCode parentName="li">{`tick`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "frame"
    }}>{`frame`}</h2>
    <Image name="modelFrame" mdxType="Image" />
    <p>{`The `}<inlineCode parentName="p">{`frame`}</inlineCode>{` is how the simulation is going to represent the data.
From the `}<inlineCode parentName="p">{`Model`}</inlineCode>{`, it reads:`}</p>
    <ul>
      <li parentName="ul">{`the current `}<inlineCode parentName="li">{`data`}</inlineCode>{`,`}</li>
      <li parentName="ul">{`the current `}<inlineCode parentName="li">{`tick`}</inlineCode>{`,`}</li>
      <li parentName="ul">{`the `}<inlineCode parentName="li">{`params`}</inlineCode></li>
    </ul>
    <p>{`and it uses that to render the simulation. Anything that can be rendered by React can go into a Frame - canvas, HTML content, SVG, you name it.`}</p>
    <Image name="modelHighLevelView" mdxType="Image" />
    <p>{`So that's how the Model and the other components interact at a high level.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      